var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CellGroup',{class:_vm.classes},[(_vm.title)?_c('h1',{class:_vm.titleCls},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default",null,{"gutter":_vm.currentGutter})],2)}
var staticRenderFns = []

export { render, staticRenderFns }